import React from 'react'
import { useEffect, useState, useRef } from 'react';
import ArticlesClass from '../ArticlesClass';
import { Button, Col, Container, Row } from "react-bootstrap";

import Article from '../components/Article';
const GET_USER_ARTICLES = `
    query GetUserArticles($page: Int!) {
        user(username: "slimshady") {
            publication {
                posts(page: $page) {
                    title
                    brief
                    slug
                    totalReactions
                    dateAdded
                }
            }
        }
    }
`;

function AllBlogs() {
    const [articles, setAllArticles] = useState([new ArticlesClass(
        "Waiting for the articles to load",
        "waiting",
        "404",
        "-1",
        "0000-00-0000"
    )])
    const countRef = useRef(0);

    useEffect(() => {
        gql(GET_USER_ARTICLES, { page: 0 })
            .then(result => {

                const articlesData = result.data.user.publication.posts;
                let li = articlesData.map(n => new ArticlesClass(n.title, n.brief, n.slug, n.totalReactions, n.dateAdded));
                setAllArticles(li)



            });
    }, [])

    useEffect(() => {
        console.log(articles)
    }, [articles])

    async function gql(query, variables = {}) {
        const data = await fetch('https://api.hashnode.com/', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query,
                variables
            })
        });

        return data.json();
    }




    return (
        <div>
            {
                articles.map(n => <Article title={n.title} brief={n.brief}/>)
            }

        </div>
    )
}

export default AllBlogs
